var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"href":_vm.app.link}},[_c('img',{attrs:{"src":_vm.app.img,"alt":""}}),_c('h5',[_vm._v(_vm._s(_vm.app.name))])])}
var staticRenderFns = []

export { render, staticRenderFns }